<template>
  <div>
    <div class="subheader">
      <img
        class="subheader__logo"
        src="/images/pay-at-table-logo.svg"
        alt="Powered by CardFree"
      >
    </div>

    <header class="header">
      <div class="header__container">
        <div class="header__left">
          <div id="simple-header-left" />
        </div>

        <component
          :is="headerClickRoute ? 'router-link' : 'div'"
          :to="headerClickRoute"
          :class="['header__logo-wrapper', { 'header__logo-wrapper-clickable': headerClickRoute }]"
        >
          <template v-if="merchant.options.logoUrl">
            <span
              class="header__logo"
              :style="{ 'background-image': `url(${merchant.options.logoUrl})` }"
            />
            <span class="ada-text">{{ merchant.name }}</span>
          </template>

          <h1
            v-else
            class="header__logo-text"
          >
            {{ merchant.name }}
          </h1>
        </component>

        <div class="header__right">
          <div id="simple-header-right" />
        </div>
      </div>
    </header>
  </div>
</template>



<script>
  import { mapGetters } from 'vuex';



  export default {
    name: 'SimpleHeader',

    props: {
      headerClickRoute: {
        type: Object,
        default: null
      }
    },

    computed: {
      ...mapGetters('merchant', ['merchant'])
    }
  };
</script>
